import React, { useReducer, useEffect, useContext } from "react";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import Details from "./partials/details/Details";
import { loadItemGeneral } from "../../../helpers/ModuleHelperFunctions";
import { detailsInitialState, detailsReducer } from "../../../reducers/module/detailsReducer";





const CartView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(detailsReducer,detailsInitialState);
  
  let { id } = useParams();
  
  
  const loadItem = async () => {
    await loadItemGeneral(id,`${moduleConfig.url}/${id}`,detailsDispatch)
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([moduleConfig.breadcrumbs.listing, moduleConfig.breadcrumbs.details]);
  }, [id]);



  return (
    <DashboardLayout>
      {detailsState.isFetching ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>

                  <Details
                    item={detailsState.data.item}
                    moduleConfig={moduleConfig}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default CartView;
